export default "<app-home [tradinSystemName]=\"tradinSytem.label\" [buttons]=\"buttons\"></app-home>";